import { put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../../utils/request';
import moment from 'moment';

const getCurrentCenterId = state => state.identity.centerId;
const getCurrentEditsToTimecards = state => state.attendance.employee.range.clockEditsById;

function * getCenterTimecardsForToday (payload) {
  try {
    const currentCenterId = yield select(getCurrentCenterId);
    const response = yield ktRequest.get(`timecards/center?centerId=${currentCenterId}`, 'timecards');
    const { all, byEmployee } = response;

    yield put(actions.getCenterTimecardsSuccess(all, byEmployee));
  } catch (error) {
    yield put(actions.getCenterTimecardsFailure(error));
  }
}

function * getEmployeeTimecardsInRange (payload) {
  try {
    const { employeeId, start, end } = payload;
    const currentCenterId = yield select(getCurrentCenterId);
    const formattedStart = moment(start).format('YYYY-MM-DD');
    const formattedEnd = moment(end).format('YYYY-MM-DD');

    const response = yield ktRequest.get(`timecards?centerId=${currentCenterId}&employeeId=${employeeId}&start=${formattedStart}&end=${formattedEnd}`, 'timecards');
    const { timecards } = response;
    yield put(actions.getEmployeeTimecardsInRangeSuccess(timecards));
  } catch (error) {
    yield put(actions.getEmployeeTimecardsInRangeFailure(error));
  }
}

function * updateTimecards (payload) {
  try {
    const currentEdits = yield select(getCurrentEditsToTimecards);
    const currentCenterId = yield select(getCurrentCenterId);

    if (Object.keys(currentEdits).length === 0) {
      yield put(actions.updateTimecardsSuccess());
      return;
    }

    const body = {
      centerId: currentCenterId,
      updates: Object.values(currentEdits)
    };

    yield ktRequest.post(`timecards/updates`, body, 'timecards');

    yield put(actions.updateTimecardsSuccess(currentEdits));
  } catch (error) {
    yield put(actions.updateTimecardsFailure());
  }
}

export const employeeAttendanceSagas = [
  takeLatest(types.GET_TODAY_CENTER_TIMECARDS_REQUEST, getCenterTimecardsForToday),
  takeLatest(types.GET_EMPLOYEE_TIMECARDS_IN_RANGE_REQUEST, getEmployeeTimecardsInRange),
  takeEvery(types.UPDATE_TIMECARDS_REQUEST, updateTimecards)
];
